export default "__VITE_ASSET__D7$tDSjE__"